import { TrackAttributesSelector } from './TrackAttributesSelector'

export default TrackAttributesSelector
